module.exports = __webpack_public_path__ + "img/car_shina2_33.a9fd7d11.jpg";